<template>
  <div>
    <h3 class="chart-title">
      {{ propChartData.title }}
    </h3>
    <div class="chart-holder">
      <LineChartGenerator
        :chart-options="chartOptions"
        :chart-data="chartData"
        :chart-id="chartId"
        :dataset-id-key="datasetIdKey"
        :plugins="plugins"
        :css-classes="cssClasses"
        :styles="styles"
        :width="width"
        :height="height"
      />
    </div>
  </div>
</template>

<script>
import { Line as LineChartGenerator } from "vue-chartjs/legacy";
import ChartPropsWatcher from "@/mixins/ChartPropsWatcher";

import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  LineElement,
  LinearScale,
  CategoryScale,
  PointElement
);

export default {
  name: "LineChart",
  components: {
    LineChartGenerator,
  },
  props: {
    propChartData: {
      type: Object,
      default: () => {},
    },
    chartId: {
      type: String,
      default: "line-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [ChartPropsWatcher],
  data() {
    return {
      values: [],
      iconsLabel: [
        require("@/assets/images/charts/chart-mood/mood-icon-1.svg"),
        require("@/assets/images/charts/chart-mood/mood-icon-2.svg"),
        require("@/assets/images/charts/chart-mood/mood-icon-3.svg"),
        require("@/assets/images/charts/chart-mood/mood-icon-4.svg"),
        require("@/assets/images/charts/chart-mood/mood-icon-5.svg"),
        require("@/assets/images/charts/chart-mood/mood-icon-6.svg"),
        require("@/assets/images/charts/chart-mood/mood-icon-7.svg"),
      ],
      plugins: [
        {
          afterDraw: (chart) => {
            let ctx = chart.ctx;
            let yAxis = chart.scales.y;

            yAxis.ticks.forEach((value, index) => {
              var y = yAxis.getPixelForTick(index);
              var image = new Image();
              image.src = this.iconsLabel[index];
              ctx.drawImage(image, 10, y - 12);
            });
          },
        },
      ],
      chartOptions: {
        layout: {
          padding: {
            top: 25,
            left: 15,
            right: 20,
            bottom: -20,
          },
        },
        responsive: true,
        maintainAspectRatio: false,

        plugins: {
          legend: {
            display: false,
          },
        },
        scales: {
          x: {
            title: {
              display: true,
              font: {
                size: 20,
              },
            },
            grid: {
              display: false,
            },
            ticks: {
              beginAtZero: false,
              source: "data",
              autoSkip: true,
              maxTicksLimit: 7,
            },
          },
          y: {
            title: {
              display: true,
            },
            ticks: {
              display: false,
            },
            grid: {
              color: "#D8D8D8",
              drawBorder: false,
            },
            suggestedMin: 1,
            suggestedMax: 7,
          },
        },
      },
    };
  },
  computed: {
    chartData() {
      return {
        labels: this.convertedLabels,
        datasets: [
          {
            label: false,
            pointStyle: false,
            pointRadius: 3,
            data: this.values,
            backgroundColor: (ctx) => {
              const canvas = ctx.chart.ctx;
              const gradient = canvas.createLinearGradient(0, 0, 0, 500);

              gradient.addColorStop(0.0, "#f36464");
              gradient.addColorStop(0.1, "#fb976c");
              gradient.addColorStop(0.2, "#f8b147");
              gradient.addColorStop(0.3, "#96dd94");
              gradient.addColorStop(0.4, "#5faef8");
              gradient.addColorStop(0.5, "#896cfe");
              gradient.addColorStop(0.6, "#615efe");

              return gradient;
            },
            borderColor: (ctx) => {
              const canvas = ctx.chart.ctx;
              const gradient = canvas.createLinearGradient(0, 0, 0, 500);

              gradient.addColorStop(0.0, "#f36464");
              gradient.addColorStop(0.1, "#fb976c");
              gradient.addColorStop(0.2, "#f8b147");
              gradient.addColorStop(0.3, "#96dd94");
              gradient.addColorStop(0.4, "#5faef8");
              gradient.addColorStop(0.5, "#896cfe");
              gradient.addColorStop(0.6, "#615efe");

              return gradient;
            },
          },
        ],
      };
    },
  },
};
</script>
